import * as moment from 'moment-timezone'
import { YumTimeZoneSelectOption } from './YumTimeZoneSelect'

export const getTimeZoneOptions = () => {
  const timeZones = moment.tz.names()
  const offsetTmz = []

  for (const i in timeZones) {
    const tz = timeZones[i]
    if ((tz.indexOf('/') < 0 && tz !== 'UTC') || tz.startsWith('Etc/')) {
      continue
    }

    const tzOffset = moment.tz(tz).format('Z')
    const timeZoneOption: YumTimeZoneSelectOption = {
      label: `(GMT${tzOffset}) ${tz} `,
      value: tz,
      offset: tzOffset,
    }
    offsetTmz.push(timeZoneOption)
  }

  offsetTmz.sort((a, b) => {
    if (a.offset === b.offset) {
      if (a.value === 'UTC') {
        return -1
      }
      return a.value === b.value ? 0 : a.value > b.value ? 1 : -1
    }
    const afc = a.offset.charAt(0)
    const bfc = b.offset.charAt(0)
    if (afc === '-') {
      if (bfc === '+') {
        return -1
      }
      return a.offset > b.offset ? -1 : 1
    }
    if (bfc === '-') {
      return 1
    }
    return a.offset > b.offset ? 1 : -1
  })

  return offsetTmz
}
